import Model  from '@/utils/v01/ActiveModel';
import User   from '@/utils/models/User';

import Survey from './Survey';
import Node   from './master/Node';
import Tps    from './master/Tps';

export default class Respon extends Model { 
    static backend = '/survey/respon/';    
    
    static entity = 'respon';    
    
    static fields () {
        return {
            id: this.attr(null),
            offline_id: this.attr(null),
            client_id: this.attr(null),
            jilid_id: this.attr(null),
            responden_id: this.attr(null),
            code: this.attr(''),
            date: this.attr(''),
            name: this.attr(''),
            phone: this.attr(''),
            gender: this.attr(''),
            tps_id: this.attr(null),
            address: this.attr(''),
            addr_idpro: this.attr(null),
            addr_idkab: this.attr(null),
            addr_idkec: this.attr(null),
            addr_idkel: this.attr(null),
            created_at: this.attr(parseInt(Date.now()/1000)),
            created_by: this.attr(User.attributes().cid),
            updated_at: this.attr(null),
            updated_by: this.attr(null),
            image: this.attr(null),
            geom: this.attr(null),
            let: this.attr(null),
            lng: this.attr(null),
            responDtls: this.attr([]),
        }
    }    

    static jilid(params={}){
      return this.api.get('/survey/jilid/view', params).then(res => {          
        return res.status == 200 ? res.data : Survey.query().where((survey) => {
            return survey.id == params.id
        }).first();
      });
    }

    static fetch(body){
        return this.api.post(this.backend+'fetch', body);
    }

    static node(params={}){        
        return this.api.get('/master/node/view', params).then(res => {          
            return res.status == 200 ? res.data : Node.query().where((node)=>{
                return node.id == params.id;
            }).first();
        });
    }

    static provinsi(params={}){
        params = {...params,...{paging:false}}
        return this.api.get('/master/node/index', params).then(res => {          
            return res.status == 200 ? res.data.data : Node.query().where((node)=>{
                return node.parent_id == params.parent
            }).get();
        });
    }

    static kabupaten(params={}){
        params = {...params,...{paging:false}}
        return this.api.get('/master/node/index', params).then(res => {          
            return res.status == 200 ? res.data.data : Node.query().where((node)=>{
                return node.parent_id == params.parent
            }).get();
        });
    }

    static kecamatan(params={}){
        params = {...params,...{paging:false}}
        return this.api.get('/master/node/index', params).then(res => {          
            return res.status == 200 ? res.data.data : Node.query().where((node)=>{
                return node.parent_id == params.parent
            }).get();
        });
    }

    static kelurahan(params={}){
        params = {...params,...{paging:false}}
        return this.api.get('/master/node/index', params).then(res => {          
            return res.status == 200 ? res.data.data :  Node.query().where((node)=>{
                return node.parent_id == params.parent
            }).get();
        });
    }
    
    static tps(params={}){
        return this.api.get('/survey/tps/index', params).then(res => {          
            return res.status == 200 ? res.data : {data:Tps.query().where((tps)=>{
                return tps.idkel == params.idkel
            }).get()};
        });
    }
}

